import { NgForOf, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormatMediumDatePipe } from '@date/format-medium-date.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateDirective } from '@language/translate.directive';
import { IDocumentClient } from '@model/client/document-client.model';
import { IForeignAddressClient } from '@model/client/foreign-address-client.model';
import { IInstitutionBDUInfo, InstitutionInfo } from '@model/client/institution-info.model';
import { IPortugueseAddressClient } from '@model/client/portuguese-address-client.model';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavLink, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { JhiBooleanComponent } from '@util/jhi-boolean.component';
import dayjs from 'dayjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { InstitutionService } from './institution.service';

@Component({
  selector: 'flw-institution-modal',
  templateUrl: './institution-modal.component.html',
  imports: [
    NgbNav,
    NgbNavItem,
    TranslateModule,
    JhiBooleanComponent,
    FontAwesomeModule,
    TooltipModule,
    FormatMediumDatePipe,
    NgbNavOutlet,
    TranslateDirective,
    NgbNavLink,
    NgbNavContent,
    NgForOf,
    NgIf,
  ],
  standalone: true,
})
export class InstitutionModalComponent implements OnInit {
  @BlockUI() blockUI?: NgBlockUI;
  record: IInstitutionBDUInfo = new InstitutionInfo();
  @Input() institutionId?: number;

  constructor(
    protected pageService: InstitutionService,
    protected dynamicDialogRef: DynamicDialogRef,
    protected dynamicDialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.institutionId = this.dynamicDialogConfig.data?.institutionId;
    this.blockUI?.resetGlobal();
    if (this.institutionId) {
      this.blockUI?.start('A carregar');
      this.pageService.getInstitutionByExternalId(this.institutionId).subscribe({
        next: res => {
          this.blockUI?.resetGlobal();
          this.record = res.body ?? new InstitutionInfo();
        },
        error: () => {
          this.blockUI?.resetGlobal();
        },
      });
    }
  }

  clear(): void {
    this.dynamicDialogRef.close();
  }

  getExpireDate(document: IDocumentClient): string {
    if (!document.validityDate) {
      return '';
    }
    const now = dayjs();
    const validity = dayjs(document.validityDate);
    const duration = dayjs.duration(validity.diff(now));
    if (duration.milliseconds() > 0) {
      return 'Expira ' + duration.locale('pt').humanize(true);
    }
    return 'Expirou ' + duration.locale('pt').humanize(true);
  }

  trackDocumentNumber(index: number, item: IDocumentClient): string | undefined {
    return item.documentNumber;
  }

  trackId(index: number, item: any): string | undefined {
    return item.id;
  }

  getEmissionDate(document: IDocumentClient): string {
    if (!document.emissionDate) {
      return '';
    }
    const now = dayjs();
    const emissionDate = dayjs(document.emissionDate);
    const duration = dayjs.duration(emissionDate.diff(now));
    return 'Emitido ' + duration.locale('pt').humanize(true);
  }

  getPortugueseAddress(): IPortugueseAddressClient[] {
    return this.record?.portugueseAddress || [];
  }

  getForeignAddress(): IForeignAddressClient[] {
    return this.record?.foreignAddress || [];
  }
}
